import {
  GET_ACCOUNT_DISCONNECT,
  GET_ACCOUNT_DISCONNECTS,
  GET_ACCOUNT_DISCONNECTS_FAIL,
  GET_ACCOUNT_DISCONNECTS_RESPONSE,
  GET_ACCOUNT_DISCONNECT_FAIL,
  GET_ACCOUNT_DISCONNECT_RESPONSE,
  POST_ACCOUNT_DISCONNECT,
  POST_ACCOUNT_DISCONNECT_FAIL,
  POST_ACCOUNT_DISCONNECT_RESPONSE,
  PROCESS_ACCOUNT_DISCONNECTS,
  PROCESS_ACCOUNT_DISCONNECTS_FAIL,
  PROCESS_ACCOUNT_DISCONNECTS_RESPONSE,
  PUT_ACCOUNT_DISCONNECT,
  PUT_ACCOUNT_DISCONNECT_FAIL,
  PUT_ACCOUNT_DISCONNECT_RESPONSE,
  GET_WEEKLY_ACCOUNT_DISCONNECTS,
  GET_WEEKLY_ACCOUNT_DISCONNECTS_RESPONSE,
  GET_WEEKLY_ACCOUNT_DISCONNECTS_FAIL,
  GET_DISCONNECT_METRICS_REQUEST,
  GET_DISCONNECT_METRICS_RESPONSE,
  GET_DISCONNECT_METRICS_FAIL,
  GET_ACCOUNT_DISCONNECTS_FOR_QUEUE,
  GET_ACCOUNT_DISCONNECTS_FOR_QUEUE_RESPONSE,
  GET_ACCOUNT_DISCONNECTS_FOR_QUEUE_FAIL,
  GET_ACCOUNT_DISCONNECT_FOR_QUEUE_BY_UUID,
  GET_ACCOUNT_DISCONNECT_FOR_QUEUE_BY_UUID_RESPONSE,
  GET_ACCOUNT_DISCONNECT_FOR_QUEUE_BY_UUID_FAIL,
  REVERT_ACCOUNT_DISCONNECT,
  REVERT_ACCOUNT_DISCONNECT_RESPONSE,
  REVERT_ACCOUNT_DISCONNECT_FAIL,
  RESCHEDULE_ACCOUNT_DISCONNECT,
  RESCHEDULE_ACCOUNT_DISCONNECT_RESPONSE,
  RESCHEDULE_ACCOUNT_DISCONNECT_FAIL,
  MARK_DISCONNECT_AS_PENDING,
  MARK_DISCONNECT_AS_PENDING_RESPONSE,
  MARK_DISCONNECT_AS_PENDING_FAIL,
  RESEND_DISCONNECT_NOTICE,
  RESEND_DISCONNECT_NOTICE_RESPONSE,
  RESEND_DISCONNECT_NOTICE_FAIL,
  RESET,
} from "./actions";
import moment from "moment";
const today = moment().format("MM/DD/YYYY");

const initialState = {
  isLoading: false,
  accountDisconnectIsLoading: false,
  processIsLoading: false,
  error: null,
  postAccountDisconnectError: null,
  putAccountDisconnectError: null,
  accountDisconnectsTotalRows: null,
  weeklyIsLoading: false,
  weeklyError: null,
  weeklyData: null,
  metrics: {
    isLoading: false,
    error: null,
    data: null,
  },
  disconnectQueue: {
    queue: {
      isLoading: false,
      error: null,
      data: null,
    },
    queueItem: {
      isLoading: false,
      error: null,
      data: null,
    },
  },
  data: {
    accountDisconnectsList: {
      items: [],
      toDelete: [],
      toUpdate: [],
    },
    accountDisconnect: {
      type: "14",
      letterSendDate: today,
      disconnectAmount: 0,
      account: null
    },
    searchQuery: null,
  },
};

// State
export default (state = initialState, action) => {
  switch (action.type) {
    case RESET:
      return Object.assign({}, initialState);
    case GET_ACCOUNT_DISCONNECTS:
      return {
        ...state,
        error: null,
        isLoading: action.isLoading,
      };
    case GET_ACCOUNT_DISCONNECTS_RESPONSE:
      var newItems = []
      if (action.isReset) {
        newItems = action.accountDisconnects.items;
        newItems.map(newItem => {
          newItem.disconnectStatus = newItem.completed ? "Completed" : "In Progress"
        })
      } else {
        newItems = state.data.accountDisconnectsList.items.concat(action.accountDisconnects.items);

        newItems.map(newItem => {
          newItem.disconnectStatus = newItem.completed ? "Completed" : "In Progress"
        })
        console.log("disconnect")
      }
      var newStateData = state.data;
      newStateData.accountDisconnectsList.items = newItems;
      const totalRows = action.accountDisconnects.totalRows;
      return {
        ...state,
        data: newStateData,
        accountDisconnectsTotalRows: totalRows,
        error: action.error,
        isLoading: false,
      };
    case GET_ACCOUNT_DISCONNECTS_FAIL:
      return {
        ...state,
        error: action.error,
        isLoading: false,
      };
    case POST_ACCOUNT_DISCONNECT:
      return {
        ...state,
        error: null,
        isLoading: action.isLoading,
      };
    case POST_ACCOUNT_DISCONNECT_RESPONSE:
      return {
        ...state,
        postAccountDisconnectError: null,
        isLoading: false,
      };
    case POST_ACCOUNT_DISCONNECT_FAIL:
      return {
        ...state,
        postAccountDisconnectError: action.error,
        isLoading: false,
      };
    case PUT_ACCOUNT_DISCONNECT:
      return {
        ...state,
        error: null,
        isLoading: action.isLoading,
      };
    case PUT_ACCOUNT_DISCONNECT_RESPONSE:
      return {
        ...state,
        error: action.error,
        isLoading: false,
      };
    case PUT_ACCOUNT_DISCONNECT_FAIL:
      return {
        ...state,
        putAccountDisconnectError: action.error,
        isLoading: false,
      };
    case PROCESS_ACCOUNT_DISCONNECTS:
      return {
        ...state,
        error: null,
        processIsLoading: true,
      };
    case PROCESS_ACCOUNT_DISCONNECTS_RESPONSE:
      return {
        ...state,
        processIsLoading: false,
      };
    case PROCESS_ACCOUNT_DISCONNECTS_FAIL:
      return {
        ...state,
        processIsLoading: false,
      };

    case GET_WEEKLY_ACCOUNT_DISCONNECTS:
      return {
        ...state,
        weeklyError: null,
        weeklyIsLoading: action.isLoading,
      };

    case GET_WEEKLY_ACCOUNT_DISCONNECTS_RESPONSE:
      return {
        ...state,
        weeklyData: action.weeklyData,
        weeklyError: null,
        weeklyIsLoading: false,
      };

    case GET_WEEKLY_ACCOUNT_DISCONNECTS_FAIL:
      return {
        ...state,
        weeklyError: action.error,
        weeklyIsLoading: false,
      };

    case GET_DISCONNECT_METRICS_REQUEST:
      return {
        ...state,
        metrics: {
          ...state.metrics,
          isLoading: action.isLoading,
          error: null,
        },
      };

    case GET_DISCONNECT_METRICS_RESPONSE:
      return {
        ...state,
        metrics: {
          isLoading: false,
          error: null,
          data: action.metricsData,
        },
      };

    case GET_DISCONNECT_METRICS_FAIL:
      return {
        ...state,
        metrics: {
          ...state.metrics,
          isLoading: false,
          error: action.error,
        },
      };

    case GET_ACCOUNT_DISCONNECTS_FOR_QUEUE:
      return {
        ...state,
        disconnectQueue: {
          ...state.disconnectQueue,
          queue: {
            ...state.disconnectQueue.queue,
            isLoading: action.isLoading,
            error: null,
          },
        },
      };

    case GET_ACCOUNT_DISCONNECTS_FOR_QUEUE_RESPONSE:
      return {
        ...state,
        disconnectQueue: {
          ...state.disconnectQueue,
          queue: {
            isLoading: false,
            error: null,
            data: action.queueData,
          },
        },
      };

    case GET_ACCOUNT_DISCONNECTS_FOR_QUEUE_FAIL:
      return {
        ...state,
        disconnectQueue: {
          ...state.disconnectQueue,
          queue: {
            ...state.disconnectQueue.queue,
            isLoading: false,
            error: action.error,
          },
        },
      };

    case GET_ACCOUNT_DISCONNECT_FOR_QUEUE_BY_UUID:
      return {
        ...state,
        disconnectQueue: {
          ...state.disconnectQueue,
          queueItem: {
            ...state.disconnectQueue.queueItem,
            isLoading: action.isLoading,
            error: null,
          },
        },
      };

    case GET_ACCOUNT_DISCONNECT_FOR_QUEUE_BY_UUID_RESPONSE:
      return {
        ...state,
        disconnectQueue: {
          ...state.disconnectQueue,
          queueItem: {
            isLoading: false,
            error: null,
            data: action.queueItem,
          },
        },
      };

    case GET_ACCOUNT_DISCONNECT_FOR_QUEUE_BY_UUID_FAIL:
      return {
        ...state,
        disconnectQueue: {
          ...state.disconnectQueue,
          queueItem: {
            ...state.disconnectQueue.queueItem,
            isLoading: false,
            error: action.error,
          },
        },
      };

    case REVERT_ACCOUNT_DISCONNECT:
      return {
        ...state,
        isLoading: action.isLoading,
        error: null,
      };

    case REVERT_ACCOUNT_DISCONNECT_RESPONSE:
      return {
        ...state,
        isLoading: false,
        error: null,
      };

    case REVERT_ACCOUNT_DISCONNECT_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.error,
      };

    case RESCHEDULE_ACCOUNT_DISCONNECT:
      return {
        ...state,
        isLoading: action.isLoading,
        error: null,
      };

    case RESCHEDULE_ACCOUNT_DISCONNECT_RESPONSE:
      return {
        ...state,
        isLoading: false,
        error: null,
      };

    case RESCHEDULE_ACCOUNT_DISCONNECT_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.error,
      };

    case MARK_DISCONNECT_AS_PENDING:
      return {
        ...state,
        isLoading: action.isLoading,
        error: null,
      };

    case MARK_DISCONNECT_AS_PENDING_RESPONSE:
      return {
        ...state,
        isLoading: false,
        error: null,
      };

    case MARK_DISCONNECT_AS_PENDING_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.error,
      };

    case RESEND_DISCONNECT_NOTICE:
      return {
        ...state,
        isLoading: action.isLoading,
        error: null,
      };

    case RESEND_DISCONNECT_NOTICE_RESPONSE:
      return {
        ...state,
        isLoading: false,
        error: null,
      };

    case RESEND_DISCONNECT_NOTICE_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.error,
      };

    default:
      return {
        ...state,
      };
  }
};
